export enum ExamTypes {
    ChapterByChapter,
    ExhaustiveTest,
    ProficiencyTest,
}